<div
    class="row-container"
    [ngbPopover]="tooltipTemplate"
    [openDelay]="300"
    [closeDelay]="300"
    triggers="mouseenter:mouseleave"
    container="body"
    popoverClass="rask-icon-popover"
>
    <i class="fal fa-sm fa-minus icon" aria-hidden="true"></i>
    <span>{{ input.title }}</span>
</div>
